/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useCancelBatchEligibilityRequest
 */
import api from 'client/index';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import AppEvents from 'utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for cancel batch eligibility request
 *
 */

interface IProps {
	batchId: string;
	reason: string;
}

const useCancelBatchEligibilityRequest = (): UseMutationResult<any, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ batchId, reason }) => {
			await api.EzapiApi.cancelBatchEligibilityRequest(batchId, reason);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.batchEligibilityRequest] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useCancelBatchEligibilityRequest;
